// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"ae9b89b7","977":"3c781408"}[chunkId] + ".chunk.js";
};